/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {Input} from "reactstrap";
import {i18n} from "../../language/i18n";

class HearText extends Component {

    constructor(props) {
        super(props);

        const {replyData} = this.props;

        let hearReplyData = replyData === null ? undefined : replyData;
        let text = hearReplyData === undefined ? "" : hearReplyData['text'];
        text = text === null ? "" : text;

        this.state = {
            text: text,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.receiveReplyData(nextProps.replyData);
    }

    receiveReplyData(replyData) {

        if (replyData === undefined || replyData.text === undefined || replyData.text === null) {
            return;
        }

        this.setState({text: replyData.text});
    }


    handleChange = (event) => {
        const {hearReplies, replyIndex} = this.props;
        this.setState({text: event.target.value});

        hearReplies.updateReply(replyIndex, "text", event.target.value);
    };

    render() {
        return (
            <div className="hear-element hear-text">
                <Input id={'reply_text_' + this.props.replyIndex}
                       type="textarea"
                       rows={10}
                       onChange={this.handleChange}
                       value={this.state.text}
                />
                <small className="form-text text-muted">
                    <b className="text-danger">{i18n.t("Required.")}</b>&nbsp;
                    {i18n.t("The text to display. 2000 characters limit.")}
                </small>
            </div>
        );
    }
}

export default HearText;

